module.exports = __webpack_public_path__ + "static/media/podcastBadgeLevel5Locked.be6a2a2c.png";